import { RavenStatic } from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';

// Importing `raven-js` imports the typescript package which, as far as I can tell, is
// empty. To work around that, we're importing the main JS file and applying the type to
// it when exporting.
import Raven from 'raven-js/src/singleton';

export default Raven as RavenStatic;
export { RavenVue };
